import * as React from 'react';
import { default as Slider } from 'react-slick';
import { FacebookShareButton, PinterestShareButton, FacebookIcon } from 'react-share';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IImageData } from 'models/common';
import { Modal } from 'components';
import { IModalAction } from 'models/modal';
import { ISuggestedArticleGallery } from 'models/magazine/article/suggestedArticleGallery';
import { formatInteger, thumbUrl } from 'helpers/common';
require('./style.css');

interface IProps {
	galleryTitle?: string;
	galleryImages?: IImageData[];
	suggestedArticleGalleries?: ISuggestedArticleGallery[];
	showHeaderCloseButton?: boolean;
	t?: (key: string) => string;
	closeModal?: () => IModalAction;
	openSuggestedArticleGallery?: (e: React.SyntheticEvent, code: string, isSuggestedArticleGallery: boolean) => string;
}

export const PreviousSlide = (props) => (
	<button onClick={props.onClick} type="button" className="sliderArrow sliderPrev">
		<img src={require('containers/Html/icons/arrow_left.svg')} className="icon" />
	</button>
);

export const NextSlide = (props) => (
	<button onClick={props.onClick} type="button" className="sliderArrow sliderNext">
		<img src={require('containers/Html/icons/arrow_right.svg')} className="icon" />
	</button>
);

interface IState {
	currentImageDescription: string;
	currentImageUrl: string;
	currentSlide: number;
}

class ArticleGallery extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			currentImageDescription: this.props.galleryImages[0].description,
			currentImageUrl: this.props.galleryImages[0].href,
			currentSlide: 0,
		};

		this.beforeSlideChange = this.beforeSlideChange.bind(this);
		this.openSuggestedArticleGallery = this.openSuggestedArticleGallery.bind(this);
	}

	public componentDidMount() {
		const slides: HTMLCollectionOf<Element> = document.getElementsByClassName('slick-active');
		if (slides && slides.length > 0) {
			(slides[0] as HTMLElement).focus();
		}
	}

	private beforeSlideChange(_, nextSlide: number) {
		const { galleryImages, t } = this.props;
		this.setState({ currentSlide: nextSlide });
		if (nextSlide < galleryImages.length) {
			this.setState({
				currentSlide: nextSlide,
				currentImageDescription: galleryImages[nextSlide].description,
				currentImageUrl: galleryImages[nextSlide].href,
			});
		} else {
			this.setState({
				currentSlide: nextSlide,
				currentImageDescription: t('Magazine_Article_ArticleGallery_Label_SuggestedGalleries'),
			});
		}
		this.forceUpdate();
	}

	private openSuggestedArticleGallery(e: React.SyntheticEvent, code: string, isSuggestedArticleGallery: boolean) {
		e.preventDefault();
		this.props.openSuggestedArticleGallery(null, code, isSuggestedArticleGallery);
	}

	public render() {
		const { t, showHeaderCloseButton, closeModal, galleryTitle, galleryImages, suggestedArticleGalleries } = this.props;

		const settings: any = {
			dots: false,
			infinite: true,
			speed: 500,
			slidesToScroll: 1,
			slidesToShow: 1,
			prevArrow: <PreviousSlide />,
			nextArrow: <NextSlide />,
			beforeChange: this.beforeSlideChange,
		};

		const PinterestGalleryIcon = (
			<div style={{ width: 32, height: 32 }}>
				<svg viewBox="0 0 32 32" width="32" height="32" className="social-icon social-icon--pinterest ">
					<g>
						<circle cx="32" cy="32" r="31" fill="#cb2128" />
					</g>
					<g>
						<path d="M17.1,19.3c-0.9,0-1.8-0.5-2.1-1.1c0,0-0.5,2-0.6,2.4c-0.4,1.4-1.5,2.7-1.6,2.8c-0.1,0.1-0.2,0.1-0.2,0c0-0.2-0.3-1.9,0-3.3c0.2-0.7,1.1-4.7,1.1-4.7s-0.3-0.5-0.3-1.4c0-1.3,0.8-2.2,1.7-2.2c0.8,0,1.2,0.6,1.2,1.3c0,0.8-0.5,2-0.8,3.1c-0.2,0.9,0.5,1.7,1.4,1.7c1.6,0,2.7-2.1,2.7-4.6c0-1.9-1.3-3.3-3.6-3.3c-2.6,0-4.3,2-4.3,4.2c0,0.8,0.2,1.3,0.6,1.7c0.2,0.2,0.2,0.3,0.1,0.5c0,0.2-0.2,0.5-0.2,0.7c-0.1,0.2-0.2,0.3-0.4,0.2c-1.2-0.5-1.8-1.8-1.8-3.3c0-2.5,2.1-5.4,6.2-5.4c3.3,0,5.5,2.4,5.5,5C21.8,16.8,19.9,19.3,17.1,19.3z" />
					</g>
				</svg>
			</div>
		);

		const slides: JSX.Element[] = galleryImages.map((galleryItem, index) => {
			return (
				<div key={index} className="gallerySlide">
					<img src={thumbUrl(galleryItem.href)} />
				</div>
			);
		});

		if (suggestedArticleGalleries) {
			slides.push(
				<div key={galleryImages.length} className="gallerySlide">
					<div className="gallerySlideRecommended">
						<h1>{t('Magazine_Article_ArticleGallery_Label_GalleriesToExplore')}</h1>
						<div className="recommendedGalleries">
							{suggestedArticleGalleries.map((suggestedGallery) => {
								return (
									<a
										key={suggestedGallery.articleId}
										href="#"
										onClick={(e) => {
											this.openSuggestedArticleGallery(e, suggestedGallery.code, true);
										}}
										className="recommendedGalleryItem"
									>
										<div
											className="image"
											style={{
												backgroundColor: `#a0a0a0`,
												backgroundImage: `url(${thumbUrl(suggestedGallery.picture)})`,
											}}
										/>
										<h2>{suggestedGallery.galleryTitle}</h2>
										<h3>
											{suggestedGallery.galleryImages.length} {t('Magazine_Article_ArticleGallery_Label_Photos')}
										</h3>
									</a>
								);
							})}
						</div>
					</div>
				</div>,
			);
		}

		const slidesCount = slides.length;

		return (
			<Modal
				title={t('Magazine_Article_ArticleCard_Label_Gallery')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				hasThemes={false}
				modalClass="articleGalleryModal"
			>
				{/*
				 * Modal needs to hide scrollbar when active
				 */}
				<div className="articleGallery">
					<div className="galleryPictures">
						<div>
							<Slider {...settings} className="articleGallerySlider">
								{slides}
							</Slider>
						</div>
					</div>
					<div className="galleryDescription">
						<div className="descHolder">
							<div>
								<div>
									<h2>{galleryTitle}</h2>
								</div>
								<div>
									<h4 className="slideCounter">
										{formatInteger(this.state.currentSlide + 1)}/{formatInteger(slidesCount)}
									</h4>
									<h4>{this.state.currentImageDescription}</h4>
								</div>
							</div>
							<div className="socialMediaHolder" />
							<div className="socialMediaHolder">
								<PinterestShareButton url={this.state.currentImageUrl} media={this.state.currentImageUrl}>
									{PinterestGalleryIcon}
								</PinterestShareButton>
								<FacebookShareButton url={this.state.currentImageUrl}>
									<FacebookIcon size={32} round={true} />
								</FacebookShareButton>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export { ArticleGallery };
